import { render } from "./CoinGraph.vue?vue&type=template&id=3be3ce75"
import script from "./CoinGraph.vue?vue&type=script&lang=js"
export * from "./CoinGraph.vue?vue&type=script&lang=js"

import "./CoinGraph.vue?vue&type=style&index=0&id=3be3ce75&lang=scss"

import exportComponent from "/home/apriyadi/projects/investment-forecaster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__